/**
 * HorseDay REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 3.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { SimpleUser } from '../models/SimpleUser';
import { HttpFile } from '../http/http';

export class Suggested {
    'suggestedFollows': Array<SimpleUser>;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "suggestedFollows",
            "baseName": "suggestedFollows",
            "type": "Array<SimpleUser>",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return Suggested.attributeTypeMap;
    }

    public constructor() {
    }
}

